import { Skeleton } from '@mui/material';

const DetailsLessonsSkeleton = () => (
  <div className="flex flex-col gap-4">
    <Skeleton variant="text" width="30%" height={60} className="bg-neutral-main/20 mb-6" />
    <Skeleton animation="wave" variant="rounded" className="rounded-xl bg-neutral-main/20 h-24" />
    <Skeleton animation="wave" variant="rounded" className="rounded-xl bg-neutral-main/20 h-24" />
    <Skeleton animation="wave" variant="rounded" className="rounded-xl bg-neutral-main/20 h-24" />
  </div>
);

export default DetailsLessonsSkeleton;
